<template>
  <header>
    <div class="colm">
      <router-link class="logo_link" to="/dashboard">
        <img class="logo" src="../../assets/img/logo_v3_white.svg" alt />
      </router-link>
    </div>
    <div class="colm alignend">
      <div class="ctn-icon">
        <v-btn class="ico-data" color="#fff" to="/about" icon>
          <v-icon class="material-icons-outlined">help_outline</v-icon>
        </v-btn>
        <v-btn class="ico-data" color="#fff" icon>
          <v-icon class="material-icons-outlined">settings</v-icon>
        </v-btn>
      </div>
      <div class="ctn-action">
        <v-btn color="#fff" icon>
          <v-icon>exit_to_app</v-icon>
        </v-btn>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters(['isLogin']),
  },
  methods: {
    ...mapActions(['signOut']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/base.scss';
header {
  background: $bg-header;
  padding: 8px;
  border-bottom: 1px solid $border-dash;
  display: flex;
  flex-direction: row;
  min-height: 35px;
  .logo_link {
    margin-left: 10px;
  }
  img.logo {
    height: 40px;
  }

  .colm {
    display: flex;
    flex-basis: 50%;
    align-items: center;
    &.alignend {
      justify-content: flex-end;
    }
  }

  .ctn-icon {
    .ico-data {
      margin-right: 10px;
    }
  }
  .ctn-action {
    padding-right: 5px;
    padding-left: 10px;
  }
}
</style>
